jQuery($ => {

    if ($('.o-infographic-slider')[0]) {
        $('.o-infographic-slider .m-infographic-tiles__list').slick({
            speed: 400,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            responsive: [
                {
                    breakpoint: 951,
                    settings: {
                        slidesToShow: 1,
                        arrows: true,
                        centerMode: true
                    }
                }, {
                    breakpoint: 601,
                    settings: {
                        slidesToShow: 1,
                        arrows: true,
                        centerMode: true,
                        centerPadding: '10px'
                    }
                }
            ]
        });

        $('.o-infographic-slider__control--prev').click(function () {
            const $section = $(this).closest('section');
            const $slider = $section.find('.m-infographic-tiles__list');

            $slider.slick('slickPrev');
        });

        $('.o-infographic-slider__control--next').click(function () {
            const $section = $(this).closest('section');
            const $slider = $section.find('.m-infographic-tiles__list');

            $slider.slick('slickNext');
        });

        $('.o-infographic-slider__control').keydown(function (e) {
            const $section = $(this).closest('section');
            const $slider = $section.find('.m-infographic-tiles__list');

            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                $slider.slick('slickPrev');
            } else if (e.key === 'ArrowRight') {
                e.preventDefault();
                $slider.slick('slickNext');
            }
        });

        $('.o-infographic-slider .m-infographic-tiles__list').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            const $section = $(this).closest('section');
            const $currentPage = $section.find('.o-infographic-slider__current');

            $currentPage.text(nextSlide + 1);
        });
    }

});